import * as z from "@-/com.npmjs.zod";

export const pinyinToneKeySchema = z.enum(["0", "1", "2", "3", "4"]);

export const pinyinToneKeyList = pinyinToneKeySchema.options;

export const pinyinToneEntrySchema = z.object({
  color: z.string(),
});

export const pinyinSyllableTypeSchema = z.literal("noun");

export const pinyinSyllableEntrySchema = z.object({
  done: z.boolean().optional(),
  ipa: z.string(),
  term: z.union([z.string(), z.array(z.string())]).optional(),
  type: z.optional(pinyinSyllableTypeSchema),
});

export const pinyinDataEntrySchema = z.union([pinyinToneEntrySchema, pinyinSyllableEntrySchema]);

export const pinyinDataSchema = z
  .record(z.string(), pinyinDataEntrySchema)
  .superRefine((data, ctx) => {
    for (const toneKey of pinyinToneKeyList) {
      const entry = data[toneKey];
      if (!pinyinToneEntrySchema.safeParse(entry).success) {
        ctx.addIssue({
          code: "custom",
          message: `missing or invalid tone key ${toneKey}`,
        });
      }
    }
  });

export type PinyinToneKey = z.infer<typeof pinyinToneKeySchema>;
export type PinyinToneEntry = z.infer<typeof pinyinToneEntrySchema>;
export type PinyinSyllableType = z.infer<typeof pinyinSyllableTypeSchema>;
export type PinyinSyllableEntry = z.infer<typeof pinyinSyllableEntrySchema>;
export type PinyinDataEntry = z.infer<typeof pinyinDataEntrySchema>;
export type PinyinData = z.infer<typeof pinyinDataSchema>;
